import Marquee from "react-fast-marquee";
import { Asterisk } from "@phosphor-icons/react";
import { MARQUEE_ITEMS } from "../data/content";

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-border py-6 bg-secondary/40 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-primary/80 px-8 tracking-wide">{item}</span>
            <Asterisk size={22} weight="bold" className="text-accent" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
